export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12204.f9cda73a.jpg";